
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class ReferralOrderProductsGrid extends Serenity.EntityGrid<ReferralOrderProductsRow, any> {
        protected getColumnsKey() { return ReferralOrderProductsColumns.columnsKey; }
        protected getDialogType() { return ReferralOrderProductsDialog; }
        protected getIdProperty() { return ReferralOrderProductsRow.idProperty; }
        protected getInsertPermission() { return ReferralOrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReferralOrderProductsRow.localTextPrefix; }
        protected getService() { return ReferralOrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: ReferralOrderProductsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}